export default "__VITE_ASSET__BdGTEcgI__"